import { useState } from 'react';
import { Link } from 'react-router-dom';

const MFAUpdate = () => {
  const [showMore, setShowMore] = useState<boolean>(false);

  return (
    <div className="registerWrapperMain">
      <h2 className="loggedInText">New Security Update:</h2>
      <p>
        We&apos;ve added Multi-Factor Authentication (MFA). From now on, after entering your password, you&apos;ll need
        to enter a one-time code sent to your email to complete login.
      </p>
      <p>
        <Link
          to="#"
          onClick={() => {
            setShowMore((prev) => !prev);
          }}
        >
          Learn more{' '}
          {!showMore ? (
            <span className="material-icons" style={{ fontSize: 'inherit' }}>
              add
            </span>
          ) : (
            <span className="material-icons" style={{ fontSize: 'inherit' }}>
              remove
            </span>
          )}
        </Link>
      </p>
      {showMore && (
        <>
          <p>
            Your security is our priority. To better protect your account, we&apos;ve added Multi-Factor Authentication
            (MFA).
          </p>
          <h6 style={{ fontWeight: 'bold' }}>This means:</h6>
          <ol>
            <li>Log in with your email and password as usual.</li>
            <li>We&apos;ll send a one-time verification code to your registered email address.</li>
            <li>Enter the code to finish signing-in.</li>
          </ol>
          <p>
            This extra step helps safeguard your account from unauthorized access - even if someone knows your password.
          </p>
          <p>Going forward, every time you login, you will need to complete this quick verification step.</p>
          <p style={{ fontWeight: 'bold', marginBottom: '0px' }}>Unable to receive a code?</p>
          <p style={{ fontWeight: 'bold' }}>Please contact Customer service.</p>
        </>
      )}
    </div>
  );
};

export default MFAUpdate;
